import React, { useState, useEffect, useRef } from 'react'
import Tabs, { TabsActions } from '@material-ui/core/Tabs'
import Tab from '@material-ui/core/Tab'
import { makeStyles } from '@material-ui/core/styles'
import { Theme } from '@material-ui/core'
import { FormattedMessage } from 'react-intl'
import messages from '../../messages'
import { useRouter } from 'next/router'
import { ActiveLinkType } from '../../utils/enum'

const useStyles = makeStyles((theme: Theme) => {
  return {
    tab: {
      textTransform: 'none',
      fontSize: theme.typography.pxToRem(20),
      fontWeight: theme.typography.fontWeightMedium,
      padding: theme.spacing(2, 0),
      marginRight: theme.spacing(5),
      minWidth: 'auto',
      '& span': {
        alignItems: 'start',
      },
    },
    tabsWrapper: {
      backgroundColor: theme.palette.common.white,
      padding: theme.spacing(0, 5),
    },
  }
})

interface ProductEntryProps {
  singleProductEntry: React.ReactElement
  multiProductEntry: React.ReactElement
}

const ProductEntryTab: React.FC<ProductEntryProps> = ({
  singleProductEntry,
  multiProductEntry,
}) => {
  const router = useRouter()
  const activeLink = router?.query?.activeLink ?? ''
  const [tabValue, setTabValue] = useState(0)
  const classes = useStyles()
  const ref = useRef<TabsActions>(null)
  useEffect(() => {
    setTimeout(() => ref?.current?.updateIndicator(), 3000)
  }, [])
  const sequencePath = `${window.location.pathname}?product=${router.query.product}&activeLink=${ActiveLinkType.SequenceEntry}`
  const multiplePath = `${window.location.pathname}?product=${router.query.product}&activeLink=${ActiveLinkType.MultipleEntry}`
  const handleTabChange = (e, value) => {
    value === 0 ? router.push(sequencePath) : router.push(multiplePath)
    setTabValue(value)
  }
  React.useEffect(() => {
    activeLink === ActiveLinkType.MultipleEntry
      ? setTabValue(1)
      : setTabValue(0)
  }, [activeLink])

  return (
    <div>
      <Tabs
        value={tabValue}
        onChange={(e, value) => handleTabChange(e, value)}
        className={classes.tabsWrapper}
        action={ref}
      >
        <Tab
          label={<FormattedMessage {...messages.SINGLE_PRODUCT_ENTRY} />}
          className={classes.tab}
          id="single-product-entry-tab"
          data-testid="single-product-entry-tab"
        />
        <Tab
          label={<FormattedMessage {...messages.MULIPLE_PRODUCT_ENTRY} />}
          className={classes.tab}
          id="multiple-product-entry-tab"
          data-testid="multiple-product-entry-tab"
        />
      </Tabs>
      {tabValue === 0 && singleProductEntry}
      {tabValue === 1 && multiProductEntry}
    </div>
  )
}

export default ProductEntryTab
